import React from 'react';
import { LegalLinksEnum } from 'app/shared/enums';

import { useStyles } from './LegalLinks.styles';

export default function LegalLinks() {
  const classes = useStyles();
  return (
    <div className={classes.wrapper}>
      {LegalLinksEnum.TakLookAt}
      <a
        href={LegalLinksEnum.LinkRodo}
        target="_blank"
        rel="noopener noreferrer"
        className={classes.link}
      >
        {LegalLinksEnum.TitleRodo}
      </a>
      <a
        href={LegalLinksEnum.LinkInsuranceDistributor}
        target="_blank"
        rel="noopener noreferrer"
        className={classes.link}
      >
        {LegalLinksEnum.TitleInsuranceDistributor}
      </a>
      {LegalLinksEnum.And}
      <a
        href={LegalLinksEnum.LinkDocuments}
        target="_blank"
        rel="noopener noreferrer"
        className={classes.link}
      >
        {LegalLinksEnum.TitleILinkDocuments}
      </a>
    </div>
  );
}
